import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Text, VStack } from '@chakra-ui/react'
import { useAuth, useDisplayModal, usePin } from 'context'
import { PinResetFormType } from 'context/Pin'
import { themeColors } from 'theme'

import { CardBody, CardContainer } from 'components/CustomCard'
import { CustomModal } from 'components/CustomModal'
import { ChevronRightIcon, ResetPinIcon } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'

export const ResetPin = () => {
  const navigate = useNavigate()
  const { resetPin, checkUserPin, clearError, pinState: { loading, error } } = usePin()
  const { authState: { state: { user } } } = useAuth()
  const { openDialog, closeModal } = useDisplayModal()
  const { icon: { secondaryIconColor } } = themeColors


  const handleCheck = async () => {
    !await checkUserPin(true) && navigate('/my-vehicles')
  }

  useEffect(() => {
    handleCheck()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const handleSubmit = async (data: PinResetFormType) => {
    const result = await resetPin(data)

    result &&
      openDialog({
        content: (
          <CustomModal
            title={'¡PIN restablecido con éxito!'}
            message={'Ahora puedes crear tu nuevo PIN'}
            iconType={'success'}
            primaryButton
            primaryTextButton='Crear Pin'
            primaryButtonProps={{ rightIcon: <ChevronRightIcon fill={secondaryIconColor} /> }}
            secondaryButton
            secondaryTextButton='Omitir'
            closeGoBackPress={() => {
              closeModal()
            }}
            closeAcceptPress={() => {
              closeModal()
              navigate('/create-pin')
            }} />
        ),
        variant: 'primary',
      })
  }

  const showConfirmation = (data: PinResetFormType) => {
    openDialog({
      content: (
        <CustomModal
          title={'¿Deseas restablecer tu PIN?'}
          message={'Recuerda que después de restablecer tu PIN tendrás que crear uno nuevo para poder' +
            ' bloquear/desbloquear tu vehículo o compartirlo'}
          primaryButton
          secondaryButton
          closeGoBackPress={() => {
            closeModal()
          }}
          closeAcceptPress={() => {
            closeModal()
            handleSubmit(data)
          }} />
      ),
      variant: 'primary',
    })
  }

  const handleGoBack = () => {
    navigate('/my-vehicles')
  }

  return (
    <CardContainer isScreen hiddenStack={false} onClose={handleGoBack} headerText={'Restablece tu PIN'}>
      <CardBody>
        <VStack justifyContent={'center'} alignItems={'center'} spacing={6}>
          <Text textAlign={'center'} variant={'LG_SB'}>
            Tu PIN actual se eliminará
          </Text>
          <Text textAlign={'center'} variant={'SM'}>
            Tendrás que crear un nuevo PIN para poder usar funcionalidades de tu vehículo
            como bloquear/desbloquear y compartir
          </Text>
          <Button
            onClick={() => user && showConfirmation({ email: user.email })}
            loadingText={'Restableciendo Pin...'}
            isLoading={loading}
            disabled={loading}
            mx={'auto'}
            leftIcon={<ResetPinIcon fill={secondaryIconColor} size={7} />}>
            restablecer pin
          </Button>
        </VStack>
      </CardBody>
    </CardContainer>
  )
}
